import { useRegisterSW } from 'virtual:pwa-register/react'
import { Button, Snackbar, SnackbarContent } from '@mui/material'

// Check for SW updates every 5 minutes
const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000

export default function UpdateNotification() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return

      // Periodically check for new service worker updates
      setInterval(() => {
        registration.update()
      }, UPDATE_CHECK_INTERVAL_MS)
    },
    onRegisterError(error) {
      console.error('SW registration error:', error)
    },
  })

  if (!needRefresh) return null

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <SnackbarContent
        message="A new version is available!"
        action={
          <Button color="primary" variant="contained" size="small" onClick={() => updateServiceWorker(true)}>
            Reload
          </Button>
        }
      />
    </Snackbar>
  )
}
